<ion-grid [ngClass]="'getm-bottom-helper-card-' + variant">
  <ion-row>
    <ion-col size="12" class="getm-bottom-helper-card-content">
      <div class="getm-bottom-helper-card-text-wrapper">
        <ion-text class="getm-bottom-helper-card-description">
          {{ description }}
        </ion-text>
        <ion-text *ngIf="count" class="getm-bottom-helper-card-number">
          {{ count }}
        </ion-text>
      </div>
      <ion-icon
        *ngIf="icon"
        [name]="icon"
        class="getm-bottom-helper-card-icon"
        [color]="
          variant === 'info'
            ? 'getm-information-default'
            : 'getm-warning-default'
        "
      ></ion-icon>
    </ion-col>
  </ion-row>
</ion-grid>
